import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import styles from "@website/widget/filter/index.module.scss";
import { FilterCollapseType, useFilterCollapse } from "@website/widget/filter/useCollapse";
import { FC } from "react";
export const FilterCollapse: FC<FilterCollapseType> = properties => {
  const $ = _c(10);
  const {
    active: t0,
    className,
    containerClassName: t1
  } = properties;
  const active = t0 === undefined ? false : t0;
  const containerClassName = t1 === undefined ? "" : t1;
  const {
    children,
    containerHeight,
    allElementHeight,
    showAll,
    containerReference,
    buttonProps
  } = useFilterCollapse(properties);
  let t2;
  if ($[0] !== active || $[1] !== allElementHeight || $[2] !== buttonProps || $[3] !== children || $[4] !== className || $[5] !== containerClassName || $[6] !== containerHeight || $[7] !== containerReference || $[8] !== showAll) {
    t2 = active ? <><div className={`${styles.container} ${className} ${containerClassName}`} ref={containerReference} style={{
        maxHeight: showAll ? allElementHeight : containerHeight
      }}>{children}</div><Button {...buttonProps} /></> : <div className={containerClassName}>{children}</div>;
    $[0] = active;
    $[1] = allElementHeight;
    $[2] = buttonProps;
    $[3] = children;
    $[4] = className;
    $[5] = containerClassName;
    $[6] = containerHeight;
    $[7] = containerReference;
    $[8] = showAll;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};